import { render, staticRenderFns } from "./role-dashboard.vue?vue&type=template&id=6dc7e2d0&"
import script from "./role-dashboard.vue?vue&type=script&lang=js&"
export * from "./role-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports